import { Banner } from 'src/app/models/banner.model'

export const BANNER01: Banner = new Banner({
    idBanner: '779d0842375073e8bc58b0bad5106027',
    order: 1,
    title: '',
    content: '',
    url: '../../../assets/banners/Facebook_V 1.png'
});